import './SideMenu.css';

import React, {useContext,useEffect, useState} from 'react';
import {ContextGlobal} from '../globalProvider';
import Ajuda from '../ajuda/Ajuda';

const SideMenu = () => {

    const {state, dispatch} = useContext(ContextGlobal);

    const [displayImage, setDisplayImage] = useState([{display:'none'}, {display:'inherit'}]);

    useEffect(() => {
        if(state.sound){
            setDisplayImage([{display:'inherit'},{display:'none'}]);
        }else{
            setDisplayImage([{display:'none'}, {display:'inherit'}]);
        }
    },[state.sound]);

    const handleSound = () => {
        dispatch({type:"UpdateSound"});
    };

    return(
        <div className = 'sideMenu column nowrap centerItens'>
            <Ajuda/>
            <button className = 'sound' onClick = {handleSound}>
                <img src = '/app/CNPD-v2/images/layout/sound.png' alt = 'Desligar Música' style = {displayImage[0]}/>
                <img src = '/app/CNPD-v2/images/layout/notSound.png' alt = 'Ligar Música' style = {displayImage[1]}/>
            </button>
        </div>
    );
};

export default SideMenu;